const FacebookRoundIcon = ({ color }: any) => {
  return (
    <svg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='17' cy='17' r='16' fill='#4867AA' stroke='white' stroke-width='2' />
      <path
        d='M21.0001 10.334H19.0001C18.116 10.334 17.2682 10.6852 16.6431 11.3103C16.0179 11.9354 15.6667 12.7833 15.6667 13.6673V15.6673H13.6667V18.334H15.6667V23.6673H18.3334V18.334H20.3334L21.0001 15.6673H18.3334V13.6673C18.3334 13.4905 18.4037 13.3209 18.5287 13.1959C18.6537 13.0709 18.8233 13.0007 19.0001 13.0007H21.0001V10.334Z'
        fill='white'
      />
    </svg>
  )
}

export default FacebookRoundIcon
